var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpeningBalance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 15.25h-.516l-2.762-6.116 1.514.568a.75.75 0 0 0 .528-1.404l-7.014-2.63V3.5a.75.75 0 0 0-1.5 0v1.605L4.764 2.298a.75.75 0 0 0-.528 1.404l1.443.541-3.187 7.007H2a.75.75 0 0 0-.75.75 5.25 5.25 0 0 0 10.5 0 .75.75 0 0 0-.75-.75h-.516l-2.83-6.266 8.977 3.366-3.139 6.9H13a.75.75 0 0 0-.75.75 5.25 5.25 0 0 0 10.5 0 .75.75 0 0 0-.75-.75zm-15.5.5a3.757 3.757 0 0 1-3.675-3h7.35a3.757 3.757 0 0 1-3.675 3zm-2.36-4.5 2.358-5.184 2.34 5.184zm13.358-1.184 2.34 5.184H15.14zm.002 9.684a3.757 3.757 0 0 1-3.675-3h7.35a3.757 3.757 0 0 1-3.675 3z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningBalance);
export default __webpack_public_path__ + "static/media/opening-balance.6e9c3140b19e308f91af223ae66d5ae6.svg";
export { ForwardRef as ReactComponent };